/*=========================================================================================
  File Name: moduleScheduleMutations.js
  Description: Schedule Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import followerMutations from "./followers/mutations";

export default {
	ADD_EVENT(state, event) {
		state.events.push(event);
	},
	ADD_EVENT_TO_BEGIN(state, event) {
		state.events.unshift(event);
	},
	ADD_UNSAVED_EVENT(state, event) {
		state.unsavedEvents.push(event);
	},
	SET_SCHEDULE_EVENTS(state, events) {
		// se crea propiedad calendarId ( init_hour + id ) local en la data para ser usada como
		// id de cada evento que se pinta en el calenadrio y se ordene por este valor
		if (events !== null) {
			state.events = events.map((e) => {
				return {...e, calendarId: e.init_hour + e.id};
			});
		} else {
			state.events = [];
		}
	},
	SET_SCHEDULE_EVENTS_BY_PARTS(state, events) {
		// se crea propiedad calendarId ( init_hour + id ) local en la data para ser usada como
		// id de cada evento que se pinta en el calenadrio y se ordene por este valor
		if (events !== null) {
			state.events_per_day_reorder = state.events_per_day_reorder.concat(
				events.map((e) => {
					return {...e, calendarId: e.init_hour + e.id};
				})
			);
		} else {
			state.events_per_day_reorder = [];
		}
	},
	SET_SCHEDULE_EVENTS_PER_DAYS(state, events) {
		state.events_per_day_reorder = events;
	},
	SET_SCHEDULE_LABELS_STATUS(state, labels) {
		state.eventSatusLabels = labels;
	},
	UPDATE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		// se crea propiedad nueva propiedad calendarId para que se actualice en el state
		// Se modifica el stado de la visita para que cambie el color en el calendar
		Object.assign(state.events[eventIndex], {
			...event,
			calendarId: event.init_hour + event.event_id,
			event_status_id: 3,
		});
	},
	SELECT_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.id);
		const someEvent = state.selectedEvents.some((e) => e.id === event.id);
		if (someEvent) {
			const foundIndex = state.selectedEvents.findIndex((e) => e.event_id === event.event_id);
			state.selectedEvents.splice(foundIndex, 1);
		} else {
			state.selectedEvents.push(event);
		}
		Object.assign(state.events[eventIndex], {
			...event,
			event_status_id: someEvent ? 3 : 8,
			event_status_name: someEvent ? "RESCHEDULED" : "CANCELLED",
			event_id: event.id,
			selected: someEvent ? false : true,
		});
	},
	REMOVE_EVENT(state, events) {
		events.forEach((event) => {
			const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
			if (eventIndex >= 0) state.events.splice(eventIndex, 1);
		});
	},
	REMOVE_AVAILABLE_EVENT(state, events) {
		events.forEach((event) => {
			const eventIndex = state.events.findIndex((e) => e.id === event.id);
			if (eventIndex >= 0) state.events.splice(eventIndex, 1);
		});
	},
	CHENGE_STATUS_EVENT(state, events) {
		const eventIndex = state.events.findIndex((e) => e.id === events[0].event_id);
		if (eventIndex >= 0) {
			state.events[eventIndex].event_status_id = 8;
			state.reloadCounter = state.reloadCounter + 1;
		}
	},
	CLEAN_EVENTS(state) {
		state.events = [];
	},
	CLEAN_SELECTED_EVENTS(state) {
		state.selectedEvents = [];
	},
	SET_SELECT_EVENT(state, events) {
		state.selectedEvents = events;
	},
	SELECTED_RESOURCE(state, resource) {
		state.currentResourceId = resource ? resource.id : 0;
		state.currentResource = resource ? {...resource} : null;
	},
	REMOVE_UNSAVED_EVENT(state, eventIndex) {
		//const eventIndex = state.unsavedEvents.findIndex((e) => e.id === event.event_id)
		state.unsavedEvents.splice(eventIndex, 1);
	},
	SET_UNSAVED_EVENT(state, events) {
		state.unsavedEvents = events;
	},
	SET_CALENDAR_DATE(state, date) {
		state.calendarDate = date;
	},
	SET_REASSIGNED_DATE(state, date) {
		state.reassignDate = date;
	},
	REMOVE_POINT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.point === event.point);
		if (eventIndex >= 0) state.events.splice(eventIndex, 1);
	},
	TOGGLE_MAP(state, val) {
		state.showMap = val;
	},
	ADD_WAYPOINT(state, point) {
		state.waypoints.push({...point});
	},
	REMOVE_WAYPOINT(state, index) {
		state.waypoints.splice(index, 1);
	},
	EDIT_WAYPOINT(state, {index, point}) {
		state.waypoints[index] = {...point};
	},
	CLEAN_WAYPOINTS(state) {
		state.waypoints = [];
	},
	SET_WAYPOINTS(state, points) {
		state.waypoints = points.map((point) => {
			return {...point};
		});
	},

	SET_SCHEDULE_MAP_STATIC_IMAGE_REQUESTS(state, {visitPointId, staticMapImage}) {
		state.scheduleMapStaticImageRequests.set(visitPointId, staticMapImage);
	},
	SET_CACHED_EVENTS(state, events) {
		// check if the events are not in the cache to avoid duplicates events in the cache array
		state.cachedEvents = state.cachedEvents.concat(
			events.filter((event) => !state.cachedEvents.some((cachedEvent) => cachedEvent.id === event.id))
		);
	},
	// Schedule Followers Mutations
	...followerMutations,
};
